import type { Organization, IOrganizationRepository } from '@knownow/domain'

export class ListUserOrganizationsUseCase {
  constructor(private readonly orgRepo: IOrganizationRepository) {}

  async execute(userId: string): Promise<readonly Organization[]> {
    const memberships = await this.orgRepo.getMembersByUserId(userId)
    const orgs = await Promise.all(
      memberships.map((m) => this.orgRepo.getById(m.organizationId)),
    )
    return orgs
  }
}
